export default {
  error: (state) => state.error,
  isLoading: (state) => state.isLoading,
  isSaving: (state) => state.isSaving,
  cdd: (state) => state.cdd,
  questionnaire: (state) => state.questionnaire,
  states: (state) => state.states,
};
